export default __webpack_public_path__ + "assets/images/31cd262794a83253738ef86e86535dbd.png";